import * as React from 'react';

import { SleepingArrangementIcon } from 'models';

import { classNames } from 'uitk-react-utils';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export interface BeddingInfoProps {
  beddingIcons?: SleepingArrangementIcon[];
  heading?: string;
  iconSize?: UitkIconSize;
  isDialog?: boolean;
  name?: string;
}

export const BeddingInfo: React.FunctionComponent<BeddingInfoProps> = ({
  beddingIcons,
  heading,
  iconSize = UitkIconSize.MEDIUM,
  isDialog,
  name
}) => {
  if (!name) {
    return null;
  }

  const headingClassNames = classNames(
    {
      'uitk-type-heading-500': !isDialog,
      'uitk-type-heading-300': isDialog
    },
    {
      'all-b-margin-three': !isDialog,
      'all-b-margin-two': isDialog
    }
  );

  const beddingNameClassNames = classNames('uitk-type-paragraph-300', {
    'all-t-margin-two': !isDialog,
    'all-t-margin-one': isDialog
  });

  return (
    <>
      {heading && <h4 className={`${headingClassNames}`}>{heading}</h4>}
      {beddingIcons &&
        beddingIcons.length > 0 &&
        beddingIcons.map(
          (icon, iconIndex) =>
            icon.type && (
              <span className="all-r-margin-one" key={`icon-${iconIndex}`}>
                {Array(icon.quantity || 1)
                  .fill({})
                  .map(index => (
                    <UitkIcon key={`${name}-uitk-icon-${iconIndex}-${index}`} name={icon.type} size={iconSize} />
                  ))}
              </span>
            )
        )}
      {name && <p className={`${beddingNameClassNames}`}>{name}</p>}
    </>
  );
};
BeddingInfo.displayName = 'BeddingInfo';
